var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_76021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7949 24.2918L14.8641 18.689L9.94319 24.2918H7.86133L13.9405 17.3722L7.86133 8.7085H13.2064L16.9111 13.9891L21.5531 8.7085H23.6349L17.8379 15.3077L24.14 24.2918H18.7949ZM21.1133 22.7123H19.7117L10.8422 10.2881H12.244L15.7963 15.2628L16.4106 16.1261L21.1133 22.7123Z",
    fill: "#242E36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_76021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtTwitterLogo);
export default __webpack_public_path__ + "static/media/at_twitter_logo.e14145df6b66a55a98be301ee38779ff.svg";
export { ForwardRef as ReactComponent };